const statusEnum = {
  active: 0,
  notActive: 1,
};

export default statusEnum;
